import { useTerminalExtStore } from '../../store/terminalExtStore';
import { leafOrder } from './paneTreeModel';
import { broadcastFrom } from './paneSinks';

/**
 * Broadcast input rules, in one place (TerminalPane calls this for every
 * keystroke typed into a pane):
 *   1. only while the tab broadcasts, and never in the locked AI tab;
 *   2. only the tab's FOCUSED pane fans out (a background pane's own
 *      output-triggered writes never do);
 *   3. targets are the tab's other RUNNING panes — exited or starting panes
 *      are skipped, and an AI pane never receives typing;
 *   4. never back into the pane the keystroke came from (paneSinks).
 */
export function fanOutKeystrokes(paneId, tabId, data) {
  const st = useTerminalExtStore.getState();
  const tab = st.tabs.find((t) => t.id === tabId);
  if (!tab?.broadcast || tab.locked || tab.focusedPaneId !== paneId) return;
  const targets = leafOrder(tab.layout).filter((id) => {
    const p = st.panes[id];
    return p && p.status === 'running' && !p.ai;
  });
  broadcastFrom(paneId, targets, data);
}
